"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Styles = _interopRequireWildcard(require("./style"));
var _Icon = require("../Icon");
var _Text = _interopRequireDefault(require("../Text"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class Input extends _react.default.Component {
  render() {
    const {
      disabled,
      hasError,
      help,
      label,
      maxLength,
      id,
      name,
      onChange,
      onBlur,
      onKeyUp,
      prefix,
      placeholder,
      size,
      type,
      value,
      forwardedRef,
      required,
      icon
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(Styles.InputWrapper, null, label.length > 0 && ( /*#__PURE__*/_react.default.createElement(_Text.default, {
      htmlFor: id,
      type: "label"
    }, label)), /*#__PURE__*/_react.default.createElement(Styles.InputFieldWrapper, {
      prefix: prefix,
      size: size
    }, icon && !prefix && /*#__PURE__*/_react.default.createElement(Styles.StyledIcon, null, icon), /*#__PURE__*/_react.default.createElement(Styles.InputStyled, {
      disabled: disabled,
      hasError: hasError,
      maxLength: maxLength,
      id: id,
      name: name,
      onChange: onChange,
      onBlur: onBlur,
      onKeyUp: onKeyUp,
      prefix: prefix,
      placeholder: placeholder,
      type: type,
      size: size,
      value: value,
      ref: forwardedRef,
      required: required,
      "aria-required": required ? true : undefined,
      icon: icon
    })), help.length > 0 && ( /*#__PURE__*/_react.default.createElement(Styles.HelpTextWrapper, null, hasError && /*#__PURE__*/_react.default.createElement(_Icon.Warning, {
      size: "medium"
    }), /*#__PURE__*/_react.default.createElement(Styles.HelpText, {
      type: "help",
      htmlFor: name,
      hasError: hasError
    }, help))));
  }
}
exports.default = Input;
Input.propTypes = {
  disabled: _propTypes.default.bool,
  hasError: _propTypes.default.bool,
  required: _propTypes.default.bool,
  help: _propTypes.default.string,
  id: _propTypes.default.string,
  label: _propTypes.default.string,
  maxLength: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  placeholder: _propTypes.default.string,
  prefix: _propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    paddingLeft: _propTypes.default.string.isRequired
  }),
  onChange: _propTypes.default.func.isRequired,
  onBlur: _propTypes.default.func,
  onKeyUp: _propTypes.default.func,
  size: _propTypes.default.string,
  type: _propTypes.default.string,
  value: _propTypes.default.string,
  icon: _propTypes.default.node,
  forwardedRef: _propTypes.default.shape({
    current: _propTypes.default.any
  })
};
Input.defaultProps = {
  disabled: false,
  hasError: false,
  required: false,
  help: '',
  id: '',
  label: '',
  placeholder: '',
  size: 'regular',
  type: 'text',
  value: undefined,
  onBlur: () => {},
  onKeyUp: () => {},
  forwardedRef: undefined,
  prefix: null,
  maxLength: undefined,
  icon: undefined
};